import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewEncapsulation
} from '@angular/core';

@Component({
    selector: 'base-open-modal',
    encapsulation: ViewEncapsulation.None,
    template: `
    <div *ngIf="isOpen" class="base-amk-modal-overlay" (click)="onOverlayClick()">
  <div
    class="base-amk-modal-dialog"
    [ngClass]="{
      'base-amk-modal--sm': size === 'sm',
      'base-amk-modal--md': size === 'md',
      'base-amk-modal--lg': size === 'lg',
      'base-amk-modal--xl': size === 'xl',
      'base-amk-modal--near-full': size === 'near-full'
    }"
    (click)="$event.stopPropagation()"
  >
    <div class="base-amk-modal-content" [class.is-background-white]="isBackgroundWhite">
      
      <div
        *ngIf="showHeader"
        class="base-amk-modal-header"
        [class.base-amk-modal-header--plain]="headerStyle === 'plain'"
        [class.base-amk-modal-header--grey]="headerStyle === 'grey'"
      >
        <h5 class="base-amk-modal-title">{{ title }}</h5>
        <button *ngIf="iconClose" class="base-amk-modal-close close" (click)="onCloseClick()" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="base-amk-modal-body" [class.base-amk-modal-body--no-header]="!showHeader">
        <div *ngIf="showAmkHeader" class="base-amk-modal-header-custom">
          <h5 class="base-amk-modal-title">{{ title }}</h5>
          <button *ngIf="iconClose" class="base-amk-modal-close close" (click)="onCloseClick()" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <ng-content></ng-content>
      </div>

      <div
        *ngIf="showFooter"
        class="base-amk-modal-footer"
        [class.base-amk-modal-footer--borderless]="!footerBorder"
      >
        <ng-content select="[modal-footer]"></ng-content>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showConfirmDialog" class="base-amk-confirm-backdrop">
  <div class="base-amk-confirm-overlay" (click)="cancelDiscard()"></div>
  <div class="base-amk-confirm-dialog">
    <div class="base-amk-confirm-content">
      <div class="base-amk-confirm-icon">
        <span class="text-warning" style="font-size: 36px;">⚠️</span>
      </div>
      <h6 class="base-amk-confirm-title">Unsaved Changes</h6>
      <p class="base-amk-confirm-message">
        You have unsaved changes. Are you sure you want to discard them?
      </p>
      <div class="base-amk-confirm-actions">
        <button class="btn btn-light base-amk-confirm-btn base-amk-confirm-btn--cancel" (click)="cancelDiscard()" type="button">
          Cancel
        </button>
        <button class="btn btn-danger base-amk-confirm-btn base-amk-confirm-btn--discard" (click)="confirmDiscard()" type="button">
          Discard
        </button>
      </div>
    </div>
  </div>
</div>
  `,
    styles: [
        `
      /* ─── Overlay ─── */
      .base-amk-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1050;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      /* ─── Dialog Container ─── */
      .base-amk-modal-dialog {
        position: relative;
        z-index: 1051;
        width: 90%;
        max-width: 500px;
        max-height: 90vh;
      }

      /* Sizes */
      .base-amk-modal--sm { max-width: 300px; }
      .base-amk-modal--md { max-width: 500px; }
      .base-amk-modal--lg { max-width: 800px; }
      .base-amk-modal--xl { max-width: 1100px; }
      .base-amk-modal--near-full {
        width: 95vw;
        max-width: 95vw;
        height: 92vh;
      }
      .base-amk-modal--near-full .base-amk-modal-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .base-amk-modal--near-full .base-amk-modal-body {
        flex: 1;
        overflow-y: auto;
        padding: 0;
      }

      /* ─── Content ─── */
      .base-amk-modal-content {
        background: #f8f8f8;
        border-radius: 12px;
        border: none;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
        overflow: visible;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
      }
      .base-amk-modal-content.is-background-white { background: #fff; }

      /* ─── Header ─── */
      .base-amk-modal-header {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 16px 20px;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        flex-shrink: 0;
      }
      .base-amk-modal-header--grey {
        background-color: #f8f8f8;
        border-bottom: 1px solid #000;
      }
      .base-amk-modal-header--plain {
        background-color: #fff;
        border-bottom: 4px solid #1f2937;
      }
      .base-amk-modal-header--plain .base-amk-modal-title { font-weight: 700; }

      /* ─── Title ─── */
      .base-amk-modal-title {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #000000;
      }
      .base-amk-modal-header-custom {
        background-color: #f8f8f8;
        padding: 18px 14px;
        margin-bottom: 18px;
        border-bottom: 2px solid #000000;
      }

      /* ─── Close Button ─── */
      .base-amk-modal-close {
        background: none;
        border: none;
        color: #6b7280;
        cursor: pointer;
        font-size: 24px;
        padding: 4px;
        line-height: 1;
        display: flex;
        align-items: center;
      }

      /* ─── Body ─── */
      .base-amk-modal-body {
        padding: 20px;
        overflow: visible;
        flex: 1;
        min-height: 0;
      }
      .base-amk-modal-body--no-header {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
      }

      /* ─── Footer ─── */
      .base-amk-modal-footer {
        padding: 12px 20px;
        border-top: 1px solid #e5e7eb;
        flex-shrink: 0;
      }
      .base-amk-modal-footer--borderless { border-top: none; }

      /* ─── Confirm Dialog ─── */
      .base-amk-confirm-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1055;
      }
      .base-amk-confirm-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.35);
      }
      .base-amk-confirm-dialog {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1056;
      }
      .base-amk-confirm-content {
        background: #fff;
        border-radius: 12px;
        padding: 28px 32px;
        box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
        text-align: center;
        min-width: 340px;
      }
      .base-amk-confirm-title {
        margin: 0 0 8px;
        font-size: 16px;
        font-weight: 600;
        color: #1f2937;
      }
      .base-amk-confirm-message {
        margin: 0 0 20px;
        font-size: 14px;
        color: #6b7280;
        line-height: 1.5;
      }
      .base-amk-confirm-actions {
        display: flex;
        gap: 10px;
        justify-content: center;
      }
    `
    ]
})
export class BaseModalComponent implements OnChanges, OnDestroy {
    private static openCount = 0;
    private wasOpen = false;

    // --- Inputs (Replaced new input() API) ---
    @Input() title: string = '';
    @Input() isOpen: boolean = false;
    @Input() size: 'sm' | 'md' | 'lg' | 'xl' | 'near-full' = 'md';
    @Input() iconClose: boolean = true;
    @Input() hasChanges: boolean = false;
    @Input() showHeader: boolean = true;
    @Input() showFooter: boolean = true;
    @Input() headerStyle: 'grey' | 'plain' = 'grey';
    @Input() footerBorder: boolean = true;
    @Input() canDismissOverlay: boolean = true;
    @Input() isBackgroundWhite: boolean = false;
    @Input() showAmkHeader: boolean = true;

    // --- Outputs (Replaced new output() API) ---
    @Output() close = new EventEmitter<void>();
    @Output() confirmed = new EventEmitter<void>();

    // --- Properties (Replaced signals) ---
    showConfirmDialog: boolean = false;

    constructor() { }

    // Tracks overlay scroll blocks instead of the modern 'effect()' hook
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['isOpen']) {
            const open = this.isOpen;
            if (open && !this.wasOpen) {
                this.wasOpen = true;
                BaseModalComponent.openCount++;
                if (BaseModalComponent.openCount === 1) {
                    document.body.style.overflow = 'hidden';
                }
            } else if (!open && this.wasOpen) {
                this.handleCloseReset();
            }
        }
    }

    // Handle destruction cleanup instead of modern DestroyRef
    ngOnDestroy(): void {
        if (this.wasOpen) {
            this.handleCloseReset();
        }
    }

    private handleCloseReset(): void {
        this.wasOpen = false;
        BaseModalComponent.openCount = Math.max(0, BaseModalComponent.openCount - 1);
        if (BaseModalComponent.openCount === 0) {
            document.body.style.overflow = '';
        }
    }

    onOverlayClick(): void {
        if (this.canDismissOverlay) {
            this.attemptClose();
        }
    }

    onCloseClick(): void {
        this.attemptClose();
    }

    attemptClose(): void {
        if (this.hasChanges) {
            this.showConfirmDialog = true;
        } else {
            this.close.emit();
        }
    }

    cancelDiscard(): void {
        this.showConfirmDialog = false;
    }

    confirmDiscard(): void {
        this.showConfirmDialog = false;
        this.confirmed.emit();
        this.close.emit();
    }
}